/**
 * Feature Flags Configuration
 * 
 * This file contains all feature flags used throughout the application.
 * Each flag should have a clear name and description of its purpose.
 */

export const FeatureFlags = {
  /**
   * Controls whether the import functionality is enabled across the application
   * When true, import functionality will be disabled in all components
   * When false, import functionality will be enabled where applicable
   */
  DISABLE_IMPORTS: false,

  /**
   * Controls whether inline editing is enabled in the Control component
   * When false, inline editing will be disabled and the edit toggle will be hidden
   * When true, inline editing and the edit toggle will be available
   */
  ENABLE_INLINE_EDIT: false,

  /**
   * Controls whether bulk editing functionality is enabled in the Control component
   * When false, bulk editing will be disabled and the snackbar will be hidden
   * When true, bulk editing and the snackbar will be available
   */
  ENABLE_BULK_EDIT: true,

  /**
   * Controls whether the dashboard view is displayed in the Control component
   * When false, the dashboard view will be hidden
   * When true, the dashboard view will be displayed at the top of the control list
   */
  ENABLE_DASHBOARD_VIEW: false,
  
  /**
   * Controls whether the highlight bar is displayed in the Control component
   * When false, the highlight bar will be hidden
   * When true, a simplified highlight bar will be shown at the top of the control list
   */
  ENABLE_HIGHLIGHT_VIEW: true,

  /**
   * Controls whether the Risk Remediation feature is enabled in the application
   * When false, Risk Remediation will be hidden from the sidebar navigation
   * When true, Risk Remediation will be available in the Security menu
   */
  ENABLE_RISK_REMEDIATION: false,

  /**
   * Controls which Sidebar Navigation to use throughout the application
   * When false, the original SideBarNavigation component will be used
   * When true, the NewSideBarNavigation component will be used
   */
  USE_NEW_SIDEBAR: true,

  /**
   * Controls whether the Governance sidebar (Questionnaire, Knowledge Base,
   * Trust Center) is shown. On for the pilot — see
   * docs/2026-09-04-GOVERNANCE_QUESTIONNAIRE_AND_KNOWLEDGE_BASE.md.
   */
  ENABLE_GOVERNANCE_QUESTIONNAIRE: true,

};

// Helper functions to check feature flags
export const isFeatureEnabled = (flagName) => {
  return FeatureFlags[flagName];
};

export const isFeatureDisabled = (flagName) => {
  return !FeatureFlags[flagName];
}; 